import { render } from "./MiniUrne.vue?vue&type=template&id=26fede94"
import script from "./MiniUrne.vue?vue&type=script&lang=js"
export * from "./MiniUrne.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__